import { Image } from "@oxygen/core";
import getThemeClasses from "@oxygen/theme";
import { CSSFlex } from "GlobalComponent/CSSCore";
import { GOOGLE_ICON } from "GlobalConstant/Icons";
import React from "react";

const containerClasses = getThemeClasses(`
  height-10;
  align-items-center;
  justify-content-center;
  border-width-1;
  border-style-solid;
  border-radius-3;
  border-color-lightGray;
  bg-white;
  width-full;
`);
const imageWrapperClasses = getThemeClasses(`
  width-5;
`);
const textClasses = getThemeClasses(`
  ml-3;
  font-size-7.5;
  color-dimGray;
`);

const ContinueWithGoogle = renderProps => (
  <CSSFlex
    as="button"
    className={containerClasses}
    onClick={renderProps.onClick}
  >
    <div className={imageWrapperClasses}>
      <Image
        src={GOOGLE_ICON}
        aspectRatio="1:1"
        lazyLoad={false}
        description="Google"
      />
    </div>
    <span className={textClasses}>Continue with Google</span>
  </CSSFlex>
);

export default ContinueWithGoogle;
